import type { ProductDuration } from './core-modules';

export type SMESegment = 'high' | 'low';

export interface OmtOfferSet {
  offers: OmtOffer[];
}

export enum ConsumptionRestriction {
  NoReturnSupply = 'NO_RETURN_SUPPLY',
  HasReturnSupply = 'HAS_RETURN_SUPPLY',
}

export enum CustomerType {
  NewCustomer = 'NEW_CUSTOMER',
  ExistingCustomer = 'EXISTING_CUSTOMER',
}

export interface OmtOffer {
  campaignId: string;
  incentiveId?: string;
  highLightId?: string;
  duration: ProductDuration;
  customer?: CustomerType;
  partnerId?: string;
  offerId: string;
  consumptionRestriction?: ConsumptionRestriction;
}

export type OfferSetResponse = OmtOfferSet['offers'];
